import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/system/_auth/surveys/')({
    beforeLoad: ({ search }) => {
        // Only jump to the first tab once there's a survey to show. Without this
        // guard the tab's loader would fire with an empty organizationId, and
        // landing on the bare route needs to render the selectors instead.
        if (!search.organizationId || !search.surveyId) return;

        // `replace` keeps this out of history — otherwise going back from a tab
        // lands here and immediately redirects forward again.
        throw redirect({ to: '/system/surveys/summaries', search, replace: true });
    },
});
